import md5 from 'js-md5';
import wetvKernel from '@tencent/wetv-kernel';
import { getCookieAmend, setCookieAmend, clearAllCookie, setCookie, setLocalStorage, getLocalStorage } from './cookie';
import { errorLogReport } from './dataReporting';
import {
  vplatformInfo,
  videoAppidInfo,
  defaultLangCode,
  PTInfo,
  TVKPlatformInfo,
  ORIPTInfo,
  licenceInfo,
  LGVChannelID,
  PlatEnum,
} from './const';
import $api from '../apis/index';
const { ageisReportor } = wetvKernel;

// 节流
export function throttle(fn, delay) {
  let lastExecutionTime = 0;
  let timer;
  return function (...args) {
    const now = Date.now();
    if (now - lastExecutionTime >= delay) {
      // 超过了指定时间，立即执行
      lastExecutionTime = now;
      fn.apply(this, args);
    } else if (!timer) {
      // 在指定时间内未触发，延时执行
      const remainingTime = delay - (now - lastExecutionTime);
      timer = setTimeout(() => {
        lastExecutionTime = Date.now();
        timer = null;
        fn.apply(this, args);
      }, remainingTime);
    }
  };
}
// 防抖
export function debounce(func, wait, immediate = false) {
  let timeout;
  return function (...args) {
    const context = this;
    // 如果有定时器，先清除它
    if (timeout) clearTimeout(timeout);

    if (immediate) {
      // 如果 `immediate` 为 true，立即执行
      const callNow = !timeout; // 如果没有定时器，立即调用
      timeout = setTimeout(() => {
        timeout = null; // 延迟过后重置 timeout
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      // 否则，延迟执行
      timeout = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    }
  };
}

// }
// 获取账号类型图片
export function getAccountPicture() {
  let accountImg = '';
  if (getCookieAmend('user_type') || getCookieAmend('main_login')) {
    const userType = parseInt(getCookieAmend('user_type'), 10);
    const mainLogin = getCookieAmend('main_login');
    if (userType === 1 || mainLogin === 'facebook') {
      accountImg = require('../assets/img/accoun/facebook_d.png');
    } else if (userType === 2 || mainLogin === 'line') {
      accountImg = require('../assets/img/accoun/line_d.png');
    } else if (userType === 3 || mainLogin === 'phone') {
      accountImg = require('../assets/img/accoun/phone_d.png');
    } else if (userType === 4 || mainLogin === 'mail') {
      accountImg = require('../assets/img/accoun/mail_d.png');
    } else if (userType === 6 || mainLogin === 'apple') {
      accountImg = require('../assets/img/accoun/apple_d.png');
    } else if (userType === 7 || mainLogin === 'wechat') {
      accountImg = require('../assets/img/accoun/wechat_d.png');
    } else if (userType === 9 || mainLogin === 'google') {
      accountImg = require('../assets/img/accoun/google_d.png');
    } else {
      accountImg = '';
    }
  }
  return accountImg;
}
// 获取本地记录
export function getLocalRecords() {
  const updated = JSON.parse(localStorage.getItem('localHistory')) || [];
  const records = [];
  for (let i = 0; i < updated.length; i++) {
    records.push({
      vid: updated[i].vid,
      cid: updated[i].cid,
      modifyTime: updated[i].modifyTime,
      videoPlayTime: updated[i].videoPlayTime,
      videoTotalTime: updated[i].videoTotalTime,
    });
  }
  return records;
}

// 格式化日期
// 时间戳转换成日期时间(年月日)
export function formatDate(time, type, isFill) {
  let p = type;
  const date = new Date(time * 1000);
  const Y = date.getFullYear();
  let M = date.getMonth() + 1;
  let d = date.getDate();
  let h = date.getHours();
  let m = date.getMinutes();
  let s = date.getSeconds();

  if (isFill) {
    M = M < 10 ? `0${M}` : M;
    d = d < 10 ? `0${d}` : d;
    h = h < 10 ? `0${h}` : h;
    m = m < 10 ? `0${m}` : m;
    s = s < 10 ? `0${s}` : s;
  }
  p = p || '%Y-%M-%d %h:%m:%s';
  p = p
    .replace(/%Y/g, Y)
    .replace(/%M/g, M)
    .replace(/%d/g, d)
    .replace(/%h/g, h)
    .replace(/%m/g, m)
    .replace(/%s/g, s);
  return p;
}

// 当前时间转换成日期时间(年月日时分秒)
export function currentTime() {
  const date = new Date();
  const y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? `0${m}` : m;
  let d = date.getDate();
  d = d < 10 ? `0${d}` : d;
  let h = date.getHours();
  h = h < 10 ? `0${h}` : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? `0${minute}` : minute;
  second = second < 10 ? `0${second}` : second;
  // let timeStr = y + '-' + m + '-' + d;
  // const timeStr = y + '-' + m + '-' + d + '　' + h + ':' + minute + ':' + second
  const timeStr = `${y}-${m}-${d}　${h}:${minute}:${second}`;
  return timeStr;
}
/**
 * forEach for object
 */
export function forEachValue(obj, fn) {
  Object.keys(obj).forEach(key => fn(obj[key], key));
}

export function isObject(obj) {
  return obj !== null && typeof obj === 'object';
}

export function isPromise(val) {
  return !!(val && typeof val.then === 'function');
}

export function assert(condition, msg) {
  if (!condition) throw new Error(`[vuex] ${msg}`);
}

/**
 * @description 日期格式转换函数
 * @param time
 * @param cFormat
 * @returns {*}
 */
// export function parseTime(time, cFormat) {
//   if (arguments.length === 0) {
//     return null;
//   }
//   const format = cFormat || `{y}-{m}-{d} {h}:{i}:{s}`;
//   let date;
//   if (typeof time === 'object') {
//     date = time;
//   } else {
//     if (('' + time).length === 10) time = parseInt(time) * 1000;
//     date = new Date(time);
//   }
//   const formatObj = {
//     y: date.getFullYear(),
//     m: date.getMonth() + 1,
//     d: date.getDate(),
//     h: date.getHours(),
//     i: date.getMinutes(),
//     s: date.getSeconds(),
//     a: date.getDay()
//   };
//   const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
//     let value = formatObj[key]
//     if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
//     if (result.length > 0 && value < 10) {
//       value = '0' + value
//     }
//     return value || 0
//   })
//   return timeStr
// }

/**
 * @description 日期格式化
 * @param time
 * @param option
 * @returns {*}
 */
// export function formatTime(time, option) {
//   time = +time * 1000;
//   const d = new Date(time);
//   const now = Date.now();

//   const diff = (now - d) / 1000;

//   if (diff < 30) {
//     return '刚刚';
//   } else if (diff < 3600) { // less 1 hour
//     return Math.ceil(diff / 60) + '分钟前';
//   } else if (diff < 3600 * 24) {
//     return Math.ceil(diff / 3600) + '小时前';
//   } else if (diff < 3600 * 24 * 2) {
//     return '1天前';
//   }
//   if (option) {
//     return parseTime(time, option);
//   } else {
//     return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
//   }
// }

export function time() {
  const myDate = new Date();
  const year = myDate.getFullYear(); // 年

  const mouth = myDate.getMonth() + 1; // 月

  const date = myDate.getDate() < 10 ? `0${myDate.getDate()}` : myDate.getDate(); // 日

  const hours = myDate.getHours() < 10 ? `0${myDate.getHours()}` : myDate.getHours(); // 时

  // let minutes = myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes();  // 分

  // let seconds = myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds();   // 秒

  return `${year}${mouth}${date}${hours}`;
}

/**
 * @description 清理数组中的空元素，返回新数组
 * @param originalArr
 * @returns {Array}
 */
export function cleanArray(originalArr) {
  const newArray = [];
  for (let i = 0; i < originalArr.length; i++) {
    if (originalArr[i]) {
      newArray.push(originalArr[i]);
    }
  }
  return newArray;
}

/**
 * @description json对象转换成字符串
 * @param json
 * @returns {*}
 */
export function param(json) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map((key) => {
    if (json[key] === undefined) return '';
    // return encodeURIComponent(key) + '=' +
    //   encodeURIComponent(json[key])
    return `${encodeURIComponent(key)}=${encodeURIComponent(json[key])}`;
  })).join('&');
}

/**
 * @description 获取url 后面的参数
 * @param url
 * @returns {{}}
 */
export function getQueryVariable(letiable) {
  let str = window.location.search; // 取得整个地址栏
  str = str.includes('?') ? str : window.location.href;
  str = decodeURIComponent(str);
  const num = str.indexOf('?');
  str = str.substr(num + 1); // 取得所有参数   stringlet.substr(start [, length ]
  const arr = str.split('&'); // 各个参数放到数组里
  for (let i = 0; i < arr.length; i++) {
    const pair = arr[i].split('=');
    if (pair[0] === letiable) {
      return pair[1];
    }
  }
  return false;
}
// export function deepClone(source) {
//   if (!source && typeof source !== 'object') {
//     throw new Error('error arguments', 'shallowClone');
//   }
//   const targetObj = source.constructor === Array ? [] : {};
//   for (const keys in source) {
//     if (source.hasOwnProperty(keys)) {
//       if (source[keys] && typeof source[keys] === 'object') {
//         targetObj[keys] = source[keys].constructor === Array ? [] : {};
//         targetObj[keys] = deepClone(source[keys]);
//       } else {
//         targetObj[keys] = source[keys];
//       }
//     }
//   }
//   return targetObj;
// }

export function timeFilter(params) {
  let secondTime = parseInt(params, 10);
  let min = 0;
  let hour = 0;
  let result = '';
  if (secondTime >= 60) {
    (min = parseInt(secondTime / 60, 10)), 10;
    secondTime = parseInt(secondTime % 60, 10);
    if (min >= 60) {
      hour = parseInt(min / 60, 10);
      min = parseInt(min % 60, 10);
    }
  }
  hour = hour < 10 ? `0${hour}` : hour;
  min = min < 10 ? `0${min}` : min;
  secondTime = secondTime < 10 ? `0${secondTime}` : secondTime;
  result = `${hour.toString()}:${min.toString()}:${secondTime.toString()}`;
  return result;
}

export function changeMinute(params) {
  const minArr = params.split(':');
  const second = Number(minArr[0]) * 3600 + Number(minArr[1]) * 60 + Number(minArr[2]);
  return second;
}

// 判断设备信息
export function isSanSung() {
  const vChannelId = localStorage.getItem('v_channel_id');
  return vChannelId === '16600' || vChannelId === '16599';
}

export function isLG() {
  const vChannelId = localStorage.getItem('v_channel_id');
  return !!LGVChannelID.includes(vChannelId);
}

export function isHisense() {
  const vChannelId = localStorage.getItem('v_channel_id');
  return vChannelId === '16562' || vChannelId === '16563';
}

export function isFoxxum() {
  const vChannelId = localStorage.getItem('v_channel_id');
  return vChannelId === '16602' || vChannelId === '16622';
}

export function isAstro() {
  const vChannelId = localStorage.getItem('v_channel_id');
  return vChannelId === '16614';
}

export function getShowLangKey() {
  const vChannelId = localStorage.getItem('v_channel_id');
  if (vChannelId === '16602') return 'foxxum';
  if (vChannelId === '16614') return 'astro';
  return null;
}

export function getDefinition() {
  const { userAgent } = window.navigator;
  const isUlti = /(Astro;KSTB6112;1.19)/.test(userAgent);
  if (isUlti) return 'hd';
  const isUltra = /(Astro;AS6[23]0SM;1.19)/.test(userAgent);
  if (isUltra) return 'shd';
  return false;
}

// eslint-disable-next-line
export function keycodeHandle(params) {
  let isPressingEnter = false;
  let pressTimer;
  let hasLongPressExecuted = false;

  window.document.onkeydown = eventHandler;
  window.document.onkeyup = eventHandlerkeyUp;
  function eventHandlerkeyUp(e) {
    // eslint-disable-next-line
    params.click = params.click ? params.click : () => { };
    if (e.keyCode === 13 || e.keyCode === window.VK_ENTER) {
      isPressingEnter = false;
      clearTimeout(pressTimer);
      pressTimer = null;
      if (!hasLongPressExecuted) {
        params.click();
      }
      hasLongPressExecuted = false;
    }
  }
  // eslint-disable-next-line
  function eventHandler(e) {
    const IsFoxxum = localStorage.getItem('v_channel_id') === '16602' || localStorage.getItem('v_channel_id') === '16622';
    // const VK_BACK = vChannelId === '16600' || vChannelId === '16599' ? VK_BACK : null;
    // const VK_LEFT  = vChannelId === '16600' || vChannelId === '16599' ? VK_LEFT : 412;
    // const VK_RIGHT = vChannelId === '16600' || vChannelId === '16599' ? VK_RIGHT : 417;
    // const VK_STOP = vChannelId === '16600' || vChannelId === '16599' ? VK_STOP : 19;
    // const VK_PAUSE = vChannelId === '16600' || vChannelId === '16599' ? VK_PAUSE : 19;
    // const VK_PLAY = vChannelId === '16600' || vChannelId === '16599' ? VK_PLAY : 415;
    // eslint-disable-next-line
    params.up = params.up ? params.up : () => { };
    // eslint-disable-next-line
    params.down = params.down ? params.down : () => { };
    // eslint-disable-next-line
    params.left = params.left ? params.left : () => { };
    // eslint-disable-next-line
    params.right = params.right ? params.right : () => { };
    // eslint-disable-next-line
    params.click = params.click ? params.click : () => { };
    // eslint-disable-next-line
    params.pause = params.pause ? params.pause : () => { };
    // eslint-disable-next-line
    params.play = params.play ? params.play : () => { };
    // eslint-disable-next-line
    params.playAndPause = params.playAndPause ? params.playAndPause : () => { };
    // 之前只是astro渠道添加停止功能，目前foxxum也要添加，将astroStop改名为stop
    // eslint-disable-next-line
    params.stop = params.stop ? params.stop : () => { };
    // eslint-disable-next-line
    params.longPress = params.longPress ? params.longPress : () => { };
    // eslint-disable-next-line
    params.exit = params.exit ? params.exit : () => { };
    // eslint-disable-next-line
    params.quit = params.quit ? params.quit : () => { };
    switch (e.keyCode) {
      // 三星LG返回
      case 10009:
      case 461:
      case window.VK_BACK:
        // e?.preventDefault();
        params.quit(e);
        break;
      case 8:
      case 27:
        // e?.preventDefault();
        params.exit(e);
        break;
      case 38:
      case window.VK_UP:
        // e?.preventDefault();
        params.up();
        break;
      case 40:
      case window.VK_DOWN:
        // e?.preventDefault();
        params.down();
        break;
      case 37:
      case 227:
      case 119:
      case window.VK_LEFT:
      case window.VK_REWIND:
        // e?.preventDefault();
        params.left(e.keyCode);
        break;
      case 39:
      case 228:
      case 118:
      case window.VK_RIGHT:
      case window.VK_FAST_FWD:
        // e?.preventDefault();
        params.right(e.keyCode);
        break;
      case 19:
      case 413:
      case 169:
      // case 90:
      case window.VK_STOP:
      case window.VK_PAUSE:
        // 下方注释代码用于测试停止键，90为键盘Z键
        // if ((e.keyCode === 413 && IsFoxxum) || (e.keyCode === 90 && IsFoxxum)) {
        if (e.keyCode === 413 && (IsFoxxum || isLG())) {
          // foxxum渠道的停止键键值码是413
          params.stop();
        } else {
          params.pause();
        }
        break;
      case 415:
      case 179:
      case window.VK_PLAY:
        // e?.preventDefault();
        params.play();
        break;
      case 116:
      case window.VK_PLAY_PAUSE:
        // e?.preventDefault();
        params.playAndPause();
        break;
      case 13:
      case window.VK_ENTER:
        // e?.preventDefault();
        isPressingEnter = true;
        pressTimer = setTimeout(() => {
          if (isPressingEnter && !hasLongPressExecuted) {
            params.longPress();
            hasLongPressExecuted = true;
          }
        }, 500);
        break;
      // astro stop按键
      case 117:
        params.stop();
        break;
    }
  }
}

// export function isYear(year, month, day) {
//   const currentTime = new Date();
//   const currentYear = currentTime.getFullYear();
//   const currentMonth = currentTime.getMonth() + 1;
//   const currentDay = currentTime.getDate();
//   if (!(year.length && month.length && day.length)) {
//     return false;
//   }
//   const yearNum = parseFloat(year);
//   const monthNum = parseFloat(month);
//   const dayNum = parseFloat(day);
//   if (yearNum === currentYear) {
//     if (monthNum > currentMonth) {
//       return false;
//       // eslint-disable-next-line
//     } else if (monthNum === currentMonth) {
//       // eslint-disable-next-line
//       if (dayNum > currentDay) {
//         return false;
//       }
//     }
//   }
//   if (yearNum > currentYear || yearNum < 1900) {
//     return false;
//   }
//   const twoMonthDay = yearNum % 400 === 0 && yearNum % 100 !== 0 && yearNum % 4 === 0 ? 29 : 28;
//   if (monthNum < 1 || monthNum > 12) {
//     return false;
//   }
//   if (monthNum === 1
//     || monthNum === 3
//     || monthNum === 5
//     || monthNum === 7
//     || monthNum === 8
//     || monthNum === 10
//     || monthNum === 12) {
//     if (dayNum < 1 || dayNum > 31) {
//       return false;
//     }
//   } else if (monthNum === 4 || monthNum === 6 || monthNum === 9 || monthNum === 11) {
//     if (dayNum < 1 || dayNum > 30) {
//       return false;
//     }
//   } else {
//     if (dayNum < 1 || dayNum > twoMonthDay) {
//       return false;
//     }
//   }
//   return true;
// }

export function isSupportedMSE() {
  const mediaSource = MediaSource;
  if (!mediaSource) {
    return false;
  }
  const sourceBuffer = self.SourceBuffer;
  const isTypeSupported = mediaSource
    && typeof mediaSource.isTypeSupported === 'function'
    && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');

  // if SourceBuffer is exposed ensure its API is valid
  // safari and old version of Chrome doe not expose SourceBuffer globally
  // so checking SourceBuffer.prototype is impossible
  const sourceBufferValidAPI = !sourceBuffer
    || (sourceBuffer.prototype
      && typeof sourceBuffer.prototype.appendBuffer === 'function'
      && typeof sourceBuffer.prototype.remove === 'function');
  return !!isTypeSupported && !!sourceBufferValidAPI;
}

export function getSubtitleIndex(subTitleArr, currentLanguage, setUpCurrentLanguage) {
  const defaultIdx = subTitleArr?.length > 1 ? 1 : 0;
  let index = subTitleArr.findIndex(item => item.lang === currentLanguage);
  index = index === -1 ? subTitleArr.findIndex(item => item.lang === setUpCurrentLanguage) : index;
  return index === -1 ? defaultIdx : index;
}

export function saveTheCookie() {
  const cookieObj = {};
  cookieObj.vplatform = getCookieAmend('vplatform') || '';
  cookieObj.TVKPlatform = getCookieAmend('TVKPlatform') || '';
  cookieObj.next_refresh_token = getCookieAmend('next_refresh_token') || '';
  cookieObj.PT = getCookieAmend('PT') || '';
  cookieObj.vuserid = getCookieAmend('vuserid') || '';
  cookieObj.vutoken = getCookieAmend('vutoken') || '';
  cookieObj.main_login = getCookieAmend('main_login') || '';
  cookieObj.vusession = getCookieAmend('vusession') || '';
  cookieObj.video_appid = getCookieAmend('video_appid') || '';
  cookieObj.user_type = getCookieAmend('user_type') || '';
  cookieObj.user_nick = getCookieAmend('user_nick') || '';
  cookieObj.user_gtk = getCookieAmend('user_gtk') || '';
  cookieObj.status = getCookieAmend('status') || '';
  cookieObj.lang_code = getCookieAmend('lang_code') || '';
  cookieObj.isLogin = getCookieAmend('isLogin') || '';
  cookieObj.guid = getCookieAmend('guid') || '';
  cookieObj.end = getCookieAmend('end') || '';
  cookieObj.country_code = getCookieAmend('country_code') || '';
  cookieObj.avatar = getCookieAmend('avatar') || '';
  // cookieObj.user_id = getCookieAmend('user_id') || '';
  // cookieObj.area_id = getCookieAmend('area_id') || '';
  setLocalStorage('cookieObj', cookieObj);
}

// 将localstorage中保存的cookie信息保存在cookie中
export function setTheCookie() {
  const cookieObj = getLocalStorage('cookieObj');
  if (cookieObj) {
    const cookieArr = Object.keys(cookieObj);
    cookieArr.forEach((item) => {
      if (item !== 'country_code' && cookieObj[item]) {
        setCookieAmend(item, cookieObj[item], true);
      }
    });
  }
}

// 过滤掉特殊字符
export function filterEmoji(str) {
  const patt = /([\u2700-\u27ff]|([\ud800-\udbff][\udc00-\udfff]))/g; // 检测utf16字符正则
  // eslint-disable-next-line
  str = (str && str.replace(patt, function (char) {
    // console.log(char);
    // if (char.length===2) return ' ';
    // return char;
    return '';
  })) || '';
  return str;
}

// 是否是LG webOS4.x版本
export function isNeedMp4() {
  const vChannelId = localStorage.getItem('v_channel_id');
  const { userAgent } = window.navigator;
  let tempArray = '';
  tempArray = /([Cc]hrome)\/(\d+)/.exec(userAgent);
  return !!((LGVChannelID.includes(vChannelId)) && tempArray && +tempArray[2] === 53);
}

export function reportEvent(params) {
  const vutoken = getCookieAmend('vutoken');
  const vuserid = getCookieAmend('vuserid');
  const vusession = getCookieAmend('vusession') || '';
  const ext1Arr = [
    `vutoken=${vutoken}`,
    `vusession=${vusession}`,
    `vuserid=${vuserid}`,
    `guid=${getCookieAmend('guid')}`,
    `nextFreshDate=${localStorage.getItem('nextFreshDate')}`,
    `version=${process.env.REACT_APP_SOFTWARE_INFO}`,
    `vChannelId=${localStorage.getItem('v_channel_id')}`,
  ];
  ageisReportor.reportEvent({
    name: params.name,
    ext1: ext1Arr.join('&'),
    ext2: JSON.stringify(params.ext2),
    ext3: JSON.stringify(params.ext3),
  });
}

export function requestSubtitle(url) {
  const xhr = new XMLHttpRequest();
  xhr.open('get', url);
  let Msg1;
  let Msg2;
  xhr.onreadystatechange = function () {
    if (4 === xhr.readyState) {
      const statueCode = xhr.status;
      if ((statueCode >= 200 && statueCode <= 300) || statueCode === 304) {
      } else {
        Msg1 = {
          readyState: xhr.readyState,
          responseText: xhr.responseText,
          status: xhr.status,
          withCredentials: xhr.withCredentials,
          timeout: xhr.timeout,
        };
        const xhr1 = new XMLHttpRequest();
        xhr1.open('get', url.replace(/\.vtt/gi, '.vtt.m3u8'), false);
        xhr1.onreadystatechange = function () {
          if (4 === xhr1.readyState) {
            const statueCode = xhr1.status;
            if ((statueCode >= 200 && statueCode <= 300) || statueCode === 304) {
            } else {
              Msg2 = {
                readyState: xhr1.readyState,
                responseText: xhr1.responseText,
                status: xhr1.status,
                withCredentials: xhr1.withCredentials,
                timeout: xhr1.timeout,
              };

              const content = JSON.stringify({
                Msg1,
                Msg2,
              });
              errorLogReport({
                timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
                path: url, // 接口完整路径
                err_code: xhr1.status, // 接口返回的错误码
                err_msg: 'get请求字幕失败, 不带m3u8 onReadyStateChange, 带m3u8 onReadyStateChange', // 接口返回的错误描述
                content, //  需要附加的其他内容
              });
            }
          }
        };
        xhr1.onerror = () => {
          Msg2 = {
            readyState: xhr1.readyState,
            responseText: xhr1.responseText,
            status: xhr1.status,
            withCredentials: xhr1.withCredentials,
            timeout: xhr1.timeout,
          };

          const content = JSON.stringify({
            Msg1,
            Msg2,
          });
          errorLogReport({
            timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
            path: url, // 接口完整路径
            err_code: xhr1.status, // 接口返回的错误码
            err_msg: 'get请求字幕失败,不带m3u8 onReadyStateChange, 带m3u8 onerror', // 接口返回的错误描述
            content, //  需要附加的其他内容
          });
        };
        try {
          xhr1.send();
        } catch (error) {
          Msg2 = {
            errMsg: error,
          };
          const content = JSON.stringify({
            Msg1,
            Msg2,
          });
          errorLogReport({
            timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
            path: url, // 接口完整路径
            err_code: xhr1.status, // 接口返回的错误码
            err_msg: 'get请求字幕失败,不带m3u8 onReadyStateChange, 带m3u8 xhr.send调用报错', // 接口返回的错误描述
            content, //  需要附加的其他内容
          });
        }
      }
    }
  };

  xhr.onerror = () => {
    Msg1 = {
      readyState: xhr.readyState,
      responseText: xhr.responseText,
      status: xhr.status,
      withCredentials: xhr.withCredentials,
      timeout: xhr.timeout,
    };
    const xhr1 = new XMLHttpRequest();
    xhr1.open('get', url.replace(/\.vtt/gi, '.vtt.m3u8'), false);
    xhr1.onreadystatechange = function () {
      if (4 === xhr1.readyState) {
        const statueCode = xhr1.status;
        if ((statueCode >= 200 && statueCode <= 300) || statueCode === 304) {
        } else {
          Msg2 = {
            readyState: xhr1.readyState,
            responseText: xhr1.responseText,
            status: xhr1.status,
            withCredentials: xhr1.withCredentials,
            timeout: xhr1.timeout,
          };

          const content = JSON.stringify({
            Msg1,
            Msg2,
          });
          errorLogReport({
            timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
            path: url, // 接口完整路径
            err_code: xhr1.status, // 接口返回的错误码
            err_msg: 'get请求字幕失败,不带m3u8 onerror, 带m3u8 onReadyStateChange', // 接口返回的错误描述
            content, //  需要附加的其他内容
          });
        }
      }
    };
    xhr1.onerror = () => {
      Msg2 = {
        readyState: xhr1.readyState,
        responseText: xhr1.responseText,
        status: xhr1.status,
        withCredentials: xhr1.withCredentials,
        timeout: xhr1.timeout,
      };
      const content = JSON.stringify({
        Msg1,
        Msg2,
      });
      errorLogReport({
        timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
        path: url, // 接口完整路径
        err_code: xhr1.status, // 接口返回的错误码
        err_msg: 'get请求字幕失败,不带m3u8 onerror, 带m3u8 onerror', // 接口返回的错误描述
        content, //  需要附加的其他内容
      });
    };
    try {
      xhr1.send();
    } catch (error) {
      Msg2 = {
        errMsg: error,
      };
      const content = JSON.stringify({
        Msg1,
        Msg2,
      });
      errorLogReport({
        timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
        path: url, // 接口完整路径
        err_code: xhr1.status, // 接口返回的错误码
        err_msg: 'get请求字幕失败,不带m3u8 xhr.send调用失败, 带m3u8 onReadyStateChange', // 接口返回的错误描述
        content, //  需要附加的其他内容
      });
    }
  };

  try {
    xhr.send();
  } catch (error) {
    console.log(error);
    Msg1 = {
      errMsg: error,
    };
    const xhr1 = new XMLHttpRequest();
    xhr1.open('get', url.replace(/\.vtt/gi, '.vtt.m3u8'), false);
    xhr1.onreadystatechange = function () {
      if (4 === xhr1.readyState) {
        const statueCode = xhr1.status;
        if ((statueCode >= 200 && statueCode <= 300) || statueCode === 304) {
        } else {
          Msg2 = {
            readyState: xhr1.readyState,
            responseText: xhr1.responseText,
            status: xhr1.status,
            withCredentials: xhr1.withCredentials,
            timeout: xhr1.timeout,
          };

          const content = JSON.stringify({
            Msg1,
            Msg2,
          });
          errorLogReport({
            timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
            path: url, // 接口完整路径
            err_code: xhr1.status, // 接口返回的错误码
            err_msg: 'get请求字幕失败,不带m3u8 xhr.send调用失败, 带m3u8 onReadyStateChange', // 接口返回的错误描述
            content, //  需要附加的其他内容
          });
        }
      }
    };
    xhr1.onerror = () => {
      Msg2 = {
        readyState: xhr1.readyState,
        responseText: xhr1.responseText,
        status: xhr1.status,
        withCredentials: xhr1.withCredentials,
        timeout: xhr1.timeout,
      };
      const content = JSON.stringify({
        Msg1,
        Msg2,
      });
      errorLogReport({
        timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
        path: url, // 接口完整路径
        err_code: xhr1.status, // 接口返回的错误码
        err_msg: 'get请求字幕失败,不带m3u8 xhr.send调用失败, 带m3u8 onerror', // 接口返回的错误描述
        content, //  需要附加的其他内容
      });
    };
    try {
      xhr1.send();
    } catch (error) {
      Msg2 = {
        errMsg: error,
      };
      const content = JSON.stringify({
        Msg1,
        Msg2,
      });
      errorLogReport({
        timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
        path: url, // 接口完整路径
        err_code: xhr1.status, // 接口返回的错误码
        err_msg: 'get请求字幕失败,不带m3u8 xhr.send调用失败, 带m3u8 xhr.send调用报错', // 接口返回的错误描述
        content, //  需要附加的其他内容
      });
    }
  }
}

// NetRangePTK5X不需要走Mse流，可以直接支持m3u8流播放
export function isNetRangePTK5X() {
  // 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko)
  // Chrome/56.77.34.5 Safari/537.36 QJY/2.0 PTK5.1 NETRANGEMMH'
  // return /QJY\/2.0 PTK5.1 NETRANGEMMH/.test(window?.navigator?.userAgent);
  return /QJY/.test(window?.navigator?.userAgent) && /PTK5.1 NETRANGEMMH/.test(window?.navigator?.userAgent);
}

// 取出浏览器channelId信息
const filterVChannelIdRegex = /(\d+#)/;
// 判断是否是正常的channelId
const isRightChannelRegex = /^\d+$/;
// 有时参数后会携带脏数据，导致channelId出现问题，这里手动再处理下使之尽可能正确
export function filterVChannelId(vChannelId) {
  if (!vChannelId) return '';
  if (isRightChannelRegex.test(vChannelId)) return vChannelId;
  const value = vChannelId.match(filterVChannelIdRegex);
  if (value) return value[0]?.replace(/#/, '');

  const value1 = vChannelId.match(/(\d{5})/);
  if (value1) return value1[0];
  return '';
}

// 判断是否是数组
export function isArray(arr) {
  return Array.isArray(arr) || Object.prototype.toString.call(arr) === '[object Array]';
}

// 根据domain判断是否是测试环境，目前提供给kernel的cgiEnv属性只判断了地址栏debugger参数
// 该页面isTestEnv方法
export function getIsDebugger() {
  switch (document.domain) {
    case 'test.iflix.com':
    case 'teststatic.wetv.vip':
      return true;

    default:
      return false;
  }
}

// posterInfo是海报信息
// 判断跳转链接里是否有拼接参数
const isHaveParamsReg = /\?.+/;

// 跳转到投票h5页面
export function JumpToActivityPage(posterInfo) {
  if (posterInfo.type === 5) {
    let jumpLink;
    if (isHaveParamsReg.test(posterInfo.id)) {
      const linkArray = posterInfo.id.split('?');
      jumpLink = `${linkArray[0]}?Q-UA=${encodeURIComponent(qua())}&${linkArray[1]}`;
    } else {
      jumpLink = `${posterInfo.id}?Q-UA=${encodeURIComponent(qua())}`;
    }
    window.location.href = jumpLink;
    return true;
  }
  return false;
}

// export function PosterJump() {
//   window.location.href = `https://static.wetv.vip/StaticCosPagePro/chuang-qrcode/index.html?Q-UA=${encodeURIComponent(`${qua()}`)}`
// }

export function isLogin() {
  return !!getCookieAmend('isLogin');
}

export function countDown(curTime, futureTime) {
  if (curTime > futureTime) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }
  const reduceTime = futureTime - curTime;
  const minutes = Math.floor(reduceTime / 60); // 转换为分钟数
  const hours = Math.floor(minutes / 60); // 转换为小时数
  const days = Math.floor(hours / 24); // 转换为天数

  const remainingSeconds = reduceTime % 60; // 剩余的秒数
  const remainingMinutes = minutes % 60; // 剩余的分钟数
  const remainingHours = hours % 24; // 剩余的小时数

  return {
    days,
    hours: remainingHours,
    minutes: remainingMinutes,
    seconds: remainingSeconds,
  };
}

export function countDownRefresh({
  // 倒计时初始值
  initialValue = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  },
  updateTimeFunc, // 更新时间函数
}) {
  // 将更新代码写在该方法里，页面可省掉该代码
  updateTimeFunc(initialValue);
  let { days, hours, minutes, seconds } = initialValue;
  const countDownTimer = setInterval(() => {
    if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
      updateTimeFunc({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      });
      clearInterval(countDownTimer);
    } else {
      if (seconds > 0) {
        seconds = seconds - 1;
      } else if (minutes > 0) {
        seconds = 59;
        minutes = minutes - 1;
      } else if (hours > 0) {
        seconds = 59;
        minutes = 59;
        hours = hours - 1;
      } else if (days > 0) {
        seconds = 59;
        minutes = 59;
        hours = 23;
        days = days - 1;
      }
      updateTimeFunc({
        days,
        hours,
        minutes,
        seconds,
      });
    }
  }, 1000);
  return countDownTimer;
}

export function classNames(...args) {
  let className = '';
  args.forEach((klass) => {
    if (typeof klass === 'string') {
      className += `${klass} `;
    } else if (typeof klass === 'object' && klass) {
      Object.entries(klass).forEach(([key, val]) => {
        className += `${!!val ? key : ''} `;
      });
    }
  });

  return className.trim();
}

// GUID生成
export function genGuid() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1)
    .toUpperCase();
}

// 根据domain获取videoAppid以及aegisAppid
export function getAppid() {
  const tmp = {};
  switch (document.domain) {
    case 'tv.iflix.com':
      tmp.videoAppid = '1200016';
      tmp.aegisAppid = '6o4pohlPLD4jJJQx7z';
      break;
    case 'test.iflix.com':
      tmp.videoAppid = '1200016';
      tmp.aegisAppid = 'Jjloqil4L1ygV1yz5q';
      break;
    case 'static.wetv.vip':
      tmp.videoAppid = '1200012';
      tmp.aegisAppid = 'PJg2Wf1x5OKoXgZKlD';
      break;
    case 'teststatic.wetv.vip':
      tmp.videoAppid = '1200012';
      tmp.aegisAppid = 'Dv080FEw1RkJ0mjbwa';
      break;
    default:
      break;
  }
  return tmp;
}

// 根据domain获取PT、ORIPT、TVKPlatform、licence，页面进来时没有这些信息要将这些信息存在cookie中，请求时携带
export function getQuaInfo() {
  const plat = getPlatKey();
  return {
    PT: PTInfo[plat],
    ORIPT: ORIPTInfo[plat],
    TVKPlatform: TVKPlatformInfo[plat],
    licence: licenceInfo[plat],
  };
}

// 获取请求时地址栏后拼接的Q-UA参数
export function qua() {
  const QUAInfo = getQuaInfo();
  return `QV=1&PR=VIDEO&PT=${QUAInfo.PT}&CHID=${localStorage.getItem('v_channel_id')}&`
    + `ORIPT=${QUAInfo.ORIPT}&`
    + `ORICHID=${localStorage.getItem('v_channel_id')}&SV=10&MD=${localStorage.getItem('deviceId')}&`
    + `TVKPlatform=${QUAInfo.TVKPlatform}`
    + `&LANG=${getCookieAmend('lang_code')}&DIST=${getCookieAmend('country_code')}&APPID=${getCookieAmend('video_appid')}&guid=${getCookieAmend('guid')}`
    + `&licence=${QUAInfo.licence}&timeforhj=${+new Date()}&video_appid=${getCookieAmend('video_appid')}`;
};

// 本地没有guid，生成guid并保存在本地
export function setGuid() {
  if (!getCookieAmend('guid')) {
    const guid = [
      genGuid(),
      genGuid(),
      genGuid(),
      genGuid(),
      genGuid(),
      genGuid(),
      genGuid(),
      genGuid(),
    ].join('');
    setCookieAmend('guid', guid);
  }
};

// cookie中没有vplatform,设置vplatform
export function setVplatForm(plat) {
  if (!getCookieAmend('vplatform')) {
    setCookieAmend('vplatform', vplatformInfo[plat]);
  }
}

// cookie中没有video_appid,设置video_appid
export function setVideoAppid(plat) {
  if (!getCookieAmend('video_appid')) {
    setCookieAmend('video_appid', videoAppidInfo[plat]);
  }
}

// cookie中没有lang_code,设置lang_code
export function setLangCode() {
  const i18nextLng = localStorage.getItem('i18nextLng');
  const id = localStorage.getItem('id');
  const lang = (i18nextLng && id) ? id : defaultLangCode;
  setCookieAmend('lang_code', lang);
  return lang;
}

// cookie中没有PT,设置PT
export function setPTInfo(plat) {
  setCookieAmend('PT', PTInfo[plat]);
};

// cookie中没有TVKPlatform,设置TVKPlatform
export function setTVKPlatFormInfo(plat) {
  setCookieAmend('TVKPlatform', TVKPlatformInfo[plat]);
}

// Astro退出应用后，cookie中的信息不会保留，需要设置到localstorage中
export function AstroSaveCookie() {
  if (localStorage.getItem('v_channel_id') === '16614') {
    saveTheCookie();
  }
}

// Astro退出应用后，cookie中的信息不会保留，打开应用后需将localstorage中的cookie信息取出存入到cookie中
export function AstroSetCookie() {
  if (localStorage.getItem('v_channel_id') === '16614') {
    setTheCookie();
  }
}

// 在请求前如果没有平台号，videoappid,langcode以及guid信息，设置这些信息
export function beforeRequestSetCookie(plat) {
  setGuid();
  setVplatForm(plat);
  setVideoAppid(plat);
  setLangCode();
  AstroSaveCookie();
}

// 获取会员信息并设置会员信息
export function userVIPInfo() {
  // let guid = [genGuid(), genGuid(), genGuid(), genGuid(), genGuid(), genGuid(), genGuid(), genGuid()].join('');
  const body = {
    guid: getCookieAmend('guid'),
    vplatform: getCookieAmend('vplatform'),
    vuid: getCookieAmend('vuserid'),
  };
  return $api.UserVIPInfo(body).then((res) => {
    if (res?.ret === 0) {
      const currentData = res?.data;
      if (!currentData.code && !currentData.errCode && !currentData.err_code) {
        if (currentData.end) {
          let currentEnd = currentData.end;
          currentEnd = formatDate(currentEnd);
          // 设置用户会员状态以及会员过期时间
          setCookieAmend('status', currentData.status);
          setCookieAmend('end', currentEnd);
          // Astro同步cookie中信息到localstorage中
          AstroSaveCookie();
        }
      } else {
        // 上传错误日志
        errorLogReport({
          timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
          path: global.base.UserVIPInfo, // 接口完整路径
          err_code: currentData.code.toString()
            || currentData.errCode.toString()
            || currentData.err_code.toString(), // 接口返回的错误码
          err_msg: currentData.msg || currentData.message || currentData.err_msg, // 接口返回的错误描述
          content: '', //  需要附加的其他内容
        });
      }
    } else {
      // 上传错误日志
      errorLogReport({
        timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
        path: global.base.UserVIPInfo, // 接口完整路径
        err_code: res?.ret.toString(), // 接口返回的错误码
        err_msg: res?.msg, // 接口返回的错误描述
        content: '', //  需要附加的其他内容
      });
      // 登陆态短票据失效为5006场景，提示用户重新登陆
      if (res?.ret === 15006) {
        refreshLogin(); // 登陆态失效立即刷新登陆态
      }
    }
  })
    .catch(() => {
      errorLogReport({
        timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
        content: 'Member status refresh failed', //  需要附加的其他内容
      });
    });
}

// 控制获取会员信息接口的调用频率
export const userVIPInfoThrottle = throttle(userVIPInfo, 10000);

// 由于cookie信息SameSite设置为Strict，导致有些设备请求时不会携带cookie信息，后台已经针对某些设备进行了处理
// 我们本地也进行一层兜底
export function resetLoginStatus() {
  const vutoken = getCookieAmend('vutoken');
  const vuserid = getCookieAmend('vuserid');
  const isLogin = getCookieAmend('isLogin');

  // 如果这些信息都有，但是刷新登录态失败了，则重新进行设置，并且进行上报
  if (vutoken && vuserid && isLogin) {
    const vusession = getCookieAmend('vusession') || '';
    setCookieAmend('vutoken', vutoken);
    setCookieAmend('vusession', vusession);
    setCookieAmend('vuserid', vuserid);

    reportEvent({
      name: 'change_cookie_sameSite_type', // 埋点名称
    });
  }
}

// 请求时，用户登录了，但是登录态不完整，长票据、短票据或者vuid没有，则上报异常
export function loginStatusReport(vusession, vutoken, vuid) {
  if (!vusession || !vutoken || !vuid) {
    reportEvent({
      name: 'incomplete_login_status', // 埋点名称
    });
  }
}

// 长票据过期处理
export function longStiffExpired(vutoken, plat) {
  if (!vutoken) {
    // 强提示用户重新登陆
    clearAllCookie();
    // 重新设置PT以及TVKPlatform的值
    setPTInfo(plat);
    setTVKPlatFormInfo(plat);
    // 登录态过期，由于未登录，移除下次刷新时间，并设置登录过期状态
    localStorage.removeItem('nextFreshDate');
    setCookie('loginExpired', true);
    // 如果没有guid设置guid
    setGuid();
    // 由于Astro退出应用cookie中的信息不会保存，Astro同步cookie信息到localstorage中
    AstroSaveCookie();
    // 将页面定位置登录页面
    window.location.href = '#/login/';
  }
}

// 设置下一次刷新票据时间
export function setNextRefreshTime() {
  // const nextDuration = Number(getCookieAmend('next_refresh_token')) || 1800; // 有可能取不到,单位为秒
  const nextDuration = 3600; // 有可能取不到,单位为秒
  const now = new Date().getTime(); // 获取当前时间时间戳
  // 计算出下次需要刷新登陆态日期
  const nextFreshDate = new Date(now + nextDuration * 1000);
  // 缓存刷新时间
  localStorage.setItem('nextFreshDate', nextFreshDate.toUTCString());
}

// 刷新票据函数
export function refreshLogin() {
  // 票据续期
  $api.ReNew().then((res) => {
    if (!res?.code) {
      // 设置下次登录态刷新时间
      setNextRefreshTime();
      // Astro同步cookie中下次刷新时间信息
      AstroSaveCookie();
      // 启动延时刷新登陆态
      createRefreshTimer();
    } else if (res?.code === 401) {
      // 登陆态短票据失效为401场景，提示用户重新登陆
      // 上传错误日志
      errorLogReport({
        timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
        path: global.base.ReNew, // 接口完整路径
        params: `cookie=${document?.cookie}` || '', // 接口params参数
        err_code: res?.code.toString(), // 接口返回的错误码
        err_msg: res?.msg || res?.message, // 接口返回的错误描述
        content: '', //  需要附加的其他内容
      });
      // 登录态失效，将上报中的uin信息设置为''
      ageisReportor?.updateUin({
        vuserid: '',
        vusession: getCookieAmend('vusession'),
      });
      // 登录态失效，提示用户重新登陆，和长票据失效同一个逻辑
      const plat = getPlatKey();
      longStiffExpired('', plat);
    } else if (res?.code === 400) {
      // 判断用户登录态信息是否存在，如果存在则重新设置cookie信息，并在下次进行登录态刷新
      resetLoginStatus();
    } else {
      // 上传错误日志
      errorLogReport({
        timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
        path: global.base.ReNew, // 接口完整路径
        params: `cookie=${document?.cookie}` || '', // 接口params参数
        err_code: res?.data.code.toString(), // 接口返回的错误码
        err_msg: res?.data.msg || res?.data.message, // 接口返回的错误描述
        content: '', //  需要附加的其他内容
      });
    }
  })
    .catch(() => {
      // 上传错误日志
      errorLogReport({
        timestamp: Math.floor(new Date().getTime() / 1000), //  日志的Unix时间戳
        path: global.base.ReNew, // 接口完整路径
        params: `cookie=${document?.cookie}` || '', // 接口params参数
        content: '', //  需要附加的其他内容
      });
    });
}

// 刷新登录态票据定时器
let refreshTimer = '';
// 创建登录态刷新定时器
export function createRefreshTimer() {
  try {
    const nowStamp = new Date().getTime(); // 当前时间时间戳
    if (!localStorage.getItem('nextFreshDate')) {
      // 没有nextFreshDate缓存刷新时间的情况下，立马启动刷新
      refreshLogin();
      return;
    }
    const localNextFreshStamp = new Date(`${localStorage.getItem('nextFreshDate')}`).getTime();
    const efficientDate = (localNextFreshStamp - nowStamp) * 0.8 + nowStamp; // 有效期80%的时间
    if (nowStamp > efficientDate) {
      // 当前时间大于缓存的刷新时间戳80%，立马启动刷新
      refreshLogin();
      return;
    }
    const nextDuration = parseInt(Number(localNextFreshStamp - nowStamp) * 0.8, 10); // 计算出延时刷新的时间戳，单位为毫秒
    if (typeof nextDuration === 'number') {
      if (refreshTimer) {
        clearTimeout(refreshTimer); // 清除上一次的延时处理缓存
      }
      refreshTimer = setTimeout(() => {
        refreshLogin();
      }, nextDuration);
    }
  } catch (error) {
    console.error(error);
  }
}

// 短票据刷新
export function shortStiffExpired(vusession) {
  if (vusession) {
    createRefreshTimer(); // 登陆态没有失效，启动延时刷新登陆态
  } else {
    refreshLogin(); // 登陆态失效立即刷新登陆态
  }
}

// 每次请求前都要实时刷新会员状态以及检测用户登陆票据状态，使用异步执行，不阻塞主请求
export function beforeRequest() {
  const Days = 3650; // 默认保留10年
  const exp = new Date(); // 计算过期时间
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  const plat = getPlatKey();
  beforeRequestSetCookie(plat);

  if (getCookieAmend('isLogin')) {
    const vusession = getCookieAmend('vusession'); // 登陆短票据
    const vutoken = getCookieAmend('vutoken'); // 登陆长票据
    const vuid = getCookieAmend('vuserid') || '';
    // 登陆态判断用户是否登录
    userVIPInfoThrottle(); // 实时刷新会员状态
    loginStatusReport(vusession, vutoken, vuid); // 如果登录态不完整则上报登录状态
    // 长票据过期处理
    longStiffExpired(vutoken, plat);
    // 短票据过期处理
    shortStiffExpired(vusession);
  }
}

export const paySessionIdKey = 'wetv_linux_pay_session_id';
export const getPaySessionId = () => localStorage.getItem(paySessionIdKey) || '';
// 生成支付会话ID: 时间戳+设备ID的MD5值
export function generatePaySessionId() {
  try {
    // 获取毫秒级时间戳
    const timestamp = Date.now();
    // 获取设备ID (qimei或h38)
    const deviceId = getCookieAmend('qimei') || getCookieAmend('h38') || getCookieAmend('guid') || '';
    // 拼接时间戳和设备ID
    const combinedString = `${timestamp}${deviceId}`;
    // 计算MD5
    const md5Hash = md5(combinedString);
    localStorage.setItem(paySessionIdKey, md5Hash);
    return md5Hash;
  } catch (error) {
    console.error('Failed to generate pay session id:', error);
    return '';
  }
}

export function getPlatKey() {
  if (['tv.iflix.com', 'test.iflix.com'].includes(document.domain)) return PlatEnum.IFLIX;
  try {
    const plat = location.pathname.split('/')?.[1];
    if (!plat || plat === 'tv') return PlatEnum.WETV;
    return plat;
  } catch (error) {
    return PlatEnum.WETV;
  }
}

// 获取不同设备默认的播放内核，该方法在defaultSetting中使用，该位置是可以拿到vChannelId信息的
export function getInitPlayerKernel() {
  // 如果本地有，则取本地的
  const storedPlayerKernel = localStorage.getItem('playerKernel');
  if (storedPlayerKernel && ['hls.js','origin'].includes(storedPlayerKernel)) return storedPlayerKernel;

  // 本地没有，根据设备进行判断，取最适配的
  const vChannelId = localStorage.getItem('v_channel_id');
  // netrange这个版本的PTK设置进度时会出现错误，使用原生内核播放器
  const isNetRangePTK = isNetRangePTK5X();
  const isSupported = isSupportedMSE();
  const isMp4Need = isNeedMp4();
  const isOrigin = (vChannelId === '16600' || vChannelId === '16599' || isNetRangePTK || !isSupported || isMp4Need);
  // 通过三星渠道号判断三星设备，如果是三星设备不设置内核(不支持的MSE也不设置内核)以及LG webOS 4.x版本
  if (!!isOrigin) return 'origin';
  return 'hls.js';
}
